export const contentData = {
    spanish:{
      nodata:'Sin Registro',
      error:'Sin registro',
      button:'Guardar',
      cancelButton:'Cancelar',
      image_button:'Cambiar',
      form:{
        presentation_limit_date:{
          placeholder:'Fecha Límite de Presentación'
        },
        process_status_id:{
          placeholder:'Estatus'
        },
        class_id:{
          placeholder:'Clase'
        },
        presentation_date:{
          placeholder:'Fecha de Presentación'
        },
        client_comment:{
          placeholder:'Respuesta Cliente'
        },
        responsible_id:{
          placeholder:'Responsable'
        },
        notes:{
          placeholder:'Notas'
        },
        extra_hours:{
          placeholder:'Horas Extra'
        },
        extra_charges:{
          placeholder:'Cargos Extra'
        },
        collections_charge:{
          placeholder:'Cargo a Cobranza'
        },
        completition_date:{
          placeholder:'Fecha de Completado'
        }
      }
    }
  }
